import { ReactComponent } from '*.svg';
import React from 'react';

class Footer extends React.Component{
  render(){
    return <div className='footer'>© 2020 ICM Ventilación</div>
  }
}

export default Footer;